// file-upload-modal.component.ts
import {
  Component,
  EventEmitter,
  input,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { HttpClient, HttpEventType } from "@angular/common/http";
import { CommonModule } from "@angular/common";
import { BaseUrlConstantsService } from "../../../../app/services/base-url-constants.service";
import { BackendApiService } from "../../../../app/services/backend-api.service";

@Component({
  selector: "app-file-upload-modal",
  templateUrl: "./file-upload.component.html",
  styleUrls: ["./file-upload.component.scss"],
  imports: [CommonModule],
  standalone: true,
})
export class FileUploadComponent implements OnInit {
  @Input() isOpen: boolean = false;
  @Output() closeModal = new EventEmitter<void>();
  @Output() uploadSuccess = new EventEmitter<any>();
  @Input() type: string = "powertrain"; // or 'piezeo'

  selectedFile: File | null = null;
  uploadProgress: number = 0;
  uploadedBytes: number = 0;
  totalBytes: number = 0;
  isUploading: boolean = false;
  uploadComplete: boolean = false;
  uploadError: string = "";

  constructor(private http: HttpClient, private srv: BackendApiService) {}

  ngOnInit() {}

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.selectedFile = file;
      this.uploadProgress = 0;
      this.uploadComplete = false;
      this.uploadError = "";
      this.totalBytes = file.size;
    }
    if (this.totalBytes >= 5000000) {
      // >5 mb reject
      this.selectedFile = null;
      this.uploadProgress = 0;
      this.uploadComplete = false;
      this.uploadError = "";
      this.totalBytes = 0;
      this.srv.showYellow("file size must be less than 5mb!");
      return;
    }
  }

  uploadFile(): void {
    if (!this.selectedFile) {
      return;
    }

    this.isUploading = true;
    this.uploadError = "";

    const formData = new FormData();
    formData.append("file", this.selectedFile);
    formData.append("type", this.type);

    // Always fetch token fresh from localStorage
    const token = localStorage.getItem("token");
    if (token) {
      formData.append("token", token); // ✅ add token to request body
    }

    this.http
        // .post("http://localhost:3015/images/powertrain-creation", formData, {
      .post(
        `${BaseUrlConstantsService.IMAGE_RELATIVE_URL}images/powertrain-creation`,
        formData,
        {
          reportProgress: true,
          observe: "events",
        }
      )
      .subscribe({
        next: (event) => {
          if (event.type === HttpEventType.UploadProgress && event.total) {
            this.uploadProgress = Math.round(
              (100 * event.loaded) / event.total
            );
            this.uploadedBytes = event.loaded;
            this.totalBytes = event.total;
          } else if (event.type === HttpEventType.Response) {
            this.uploadComplete = true;
            this.isUploading = false;

            // Emit success and close modal after 1.5s
            setTimeout(() => {
              this.uploadSuccess.emit(event.body);
              this.close();
            }, 1500);
          }
        },
        error: (error) => {
          this.uploadError =
            error.error?.message || "Upload failed. Please try again.";
          this.isUploading = false;
        },
      });
  }

  formatBytes(bytes: number): string {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + " " + sizes[i];
  }

  close(): void {
    if (!this.isUploading) {
      this.resetUpload();
      this.closeModal.emit();
    }
  }

  resetUpload(): void {
    this.selectedFile = null;
    this.uploadProgress = 0;
    this.uploadedBytes = 0;
    this.totalBytes = 0;
    this.isUploading = false;
    this.uploadComplete = false;
    this.uploadError = "";
  }

  onBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.close();
    }
  }
}
